/** In-memory admin access token (set after OTP verify; never persisted to storage). */
let accessToken: string | null = null;
let expiresAtMs: number | null = null;

export function setAdminAccessToken(
  token: string,
  expiresInSeconds: number,
): void {
  accessToken = token.trim();
  const ttl =
    Number.isFinite(expiresInSeconds) && expiresInSeconds > 0
      ? expiresInSeconds
      : 900;
  expiresAtMs = Date.now() + ttl * 1000;
}

export function getAdminAccessToken(): string | null {
  return accessToken;
}

export function getMsUntilAccessTokenExpiry(): number | null {
  if (expiresAtMs === null) {
    return null;
  }
  return expiresAtMs - Date.now();
}

export function isAdminAccessTokenExpired(): boolean {
  const msUntilExpiry = getMsUntilAccessTokenExpiry();
  return msUntilExpiry !== null && msUntilExpiry <= 0;
}

export function clearAdminAccessToken(): void {
  accessToken = null;
  expiresAtMs = null;
}
